<div>
    <v-app>
        <v-main>
            <HeaderComponent :key="headerData.contractCode"></HeaderComponent>
            <div class="container">
                <div class="row justify-content-center align-items-center">
                    <div class="col-12 col-md-11 col-lg-11 col-xl-11">
                        <AlertComponent :type="'success'" v-if="alertOptions.visible">
                            <div v-html="alertOptions.template"></div>
                        </AlertComponent>
                        <router-view />
                    </div>
                </div>
            </div>
        </v-main>
        <DialogComponent></DialogComponent>
    </v-app>
</div>